import { compose, get, getOr, concat, uniqBy, reject } from 'lodash/fp';
import {
    MEMBER_ADDED,
    MEMBER_REMOVED,
    MEMBERS_FETCHING,
    MEMBERS_VISIBILITY_UPDATED,
    THREAD_POSTED,
} from '../actionTypes';
import { loadingIds } from './utils';

export function members(state = {}, action: $TSFixMe) {
    switch (action.type) {
        case MEMBER_ADDED:
            return {
                ...state,
                [action.payload.threadId]: compose(
                    uniqBy('profileId'),
                    concat([action.payload.member]),
                    getOr([], action.payload.threadId)
                )(state),
            };
        case MEMBER_REMOVED:
            return {
                ...state,
                [action.payload.threadId]: compose(
                    reject((item) => (item as $TSFixMe).profileId === action.payload.memberProfileId),
                    get(action.payload.threadId)
                )(state),
            };
        case THREAD_POSTED:
            return {
                ...state,
                [action.payload.newThreadId]: get(action.payload.oldThreadId)(state),
            };
        default:
            return state;
    }
}

export function membersVisible(state = false, action: $TSFixMe) {
    switch (action.type) {
        case MEMBERS_VISIBILITY_UPDATED:
            return action.payload;
        default:
            return state;
    }
}

export const loadingMembers = loadingIds(MEMBERS_FETCHING);
